export default function pickedDateAsUtc(date: unknown): Date {
  const picked = Array.isArray(date) ? date[0] : date
  if (!(picked instanceof Date)) {
    return new Date(Number.NaN)
  }

  return new Date(
    Date.UTC(
      picked.getFullYear(),
      picked.getMonth(),
      picked.getDate(),
      picked.getHours(),
      picked.getMinutes(),
      picked.getSeconds(),
    ),
  )
}
